import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showError, showSuccess } from "../../helpers/toast";

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

API.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    // Display error message
    console.error(error.response?.data?.message || error.message);
    return Promise.reject(error);
  }
);

// Async thunk for creating a notification
export const createNotification = createAsyncThunk(
  "notifications/createNotification",
  async ({ message, user_id, accessToken, is_admin, subject, htmlMailContent, sendToGamingBoardAdmins, sendToGamingBoardReviewers, sendToCompanyAdmins, applicationId, applicationName, status }, { rejectWithValue }) => {
    try {

      // Generate generic message if not provided
      let finalMessage = message;
      let finalHtmlMailContent = htmlMailContent;
      let finalSubject = subject;

      if (applicationId && status) {
        const statusMap = {
          "descrepency_GB_GB": "Under Review by Gaming Board",
          "descrepency_GB_Company": "Returned to Company (Discrepancy)",
          "descrepency_GB_Employee": "Returned to Employee (Discrepancy)",
          "dicrepancy_application_assigned_to_comapany_user": "Assigned to Company User",
          "application_sent_to_discrepancy_by_company": "Returned to Employee",
          "in_process": "In Process",
          "approved": "Approved",
          "rejected": "Rejected",
          "drafts": "Draft",
          "submitted": "Submitted"
        };
        const statusDescription = statusMap[status] || status;

        if (!finalMessage) {
          finalMessage = `Application ${applicationName || ''} (ID: GB-${applicationId}) status updated to: ${statusDescription}`;
        }

        if (!finalSubject) {
          finalSubject = `Application Status Update: GB-${applicationId}`;
        }

        if (!finalHtmlMailContent) {
          finalHtmlMailContent = `
            <div style="font-family: Arial, sans-serif; padding: 20px; color: #333;">
              <h2 style="color: #2c3e50;">Application Status Update</h2>
              <p>Dear User,</p>
              <p>Your application <strong>${applicationName || 'Application'}</strong> (ID: <strong>GB-${applicationId}</strong>) status has been updated.</p>
              <p><strong>New Status:</strong> <span style="color: #007bff;">${statusDescription}</span></p>
              <p>Please log in to your dashboard to view more details.</p>
              <br>
              <p>Best regards,</p>
              <p>Gaming Board Team</p>
            </div>`;
        }
      }

      console.log(finalMessage, user_id);
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      };

      // Use defaults if flags are not explicitly provided
      const finalSendToCompanyAdmins = sendToCompanyAdmins !== undefined ? sendToCompanyAdmins : true;
      // For GB admins, usually only send if specifically requested or status implies it? 
      // User said "Make is consistant for all", implying we should be generous with notifications or stick to specific flags?
      // For now, respect passed flags, defaulting detailed flags to false if undefined to avoid spam, 
      // unless we want to default to true? The prompt said "make it consistant".
      // Existing code passed explicit true/false. I will stick to passed values, but maybe default to false to be safe unless logic dictates.
      // actually, let's keep the user's explicit flags from the call site if present.

      const response = await API.post(
        "/notification/",
        // Map user_id (thunk arg) to userId (API expected key)
        { message: finalMessage, userId: user_id, is_admin, sendToGamingBoardAdmins, sendToGamingBoardReviewers, sendToCompanyAdmins: finalSendToCompanyAdmins },
        config
      );
      try {
        await API.post(
          "/users/sendMail",
          {
            userId: user_id,
            subject: finalSubject || "Notification",
            htmlMailContent: finalHtmlMailContent || "<p>check your account your application status is updated</p>",
            sendToGamingBoardAdmins: sendToGamingBoardAdmins || false,
            // sendToGamingBoardViewers: sendToGamingBoardViewers || false,
            sendToGamingBoardReviewers: sendToGamingBoardReviewers || false,
            sendToCompanyAdmins: finalSendToCompanyAdmins
          },
          config
        );
      } catch (emailError) {
        console.error("Failed to send email notification", emailError);
      }
      // showSuccess('Notification created successfully');
      return response.data;
    } catch (error) {
      showError(error.response?.data?.error || "Error");
      return rejectWithValue(
        error.response?.data?.message || "Failed to create notification"
      );
    }
  }
);

// Async thunk for updating a notification
export const updateNotification = createAsyncThunk(
  "notifications/updateNotification",
  async (
    { notificationId, message, user_read_status, accessToken },
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.put(
        `/notification/${notificationId}`,
        { message, user_read_status },
        config
      );
      //   showSuccess('Notification updated successfully');
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update notification"
      );
    }
  }
);

// Async thunk for deleting a notification
export const deleteNotification = createAsyncThunk(
  "notifications/deleteNotification",
  async ({ configdata }, { rejectWithValue }) => {
    console.log(configdata.notification_ids, "nnnnnnnnnnnnnnnnn");
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${configdata.accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.delete(
        `/notification/${configdata.notification_ids}`,
        config
      );
      //   showSuccess('Notification deleted successfully');
      return configdata.notification_ids;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete notification"
      );
    }
  }
);

// Async thunk for fetching notifications
export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (accessToken, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      };
      const response = await API.get("/notification/", config);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch notifications"
      );
    }
  }
);

const initialState = {
  notifications: [],
  loading: false,
  error: null,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: {
    [createNotification.pending]: (state) => {
      state.loading = true;
    },
    [createNotification.fulfilled]: (state, action) => {
      state.loading = false;
      state.notifications.push(action.payload);
      state.error = null;
    },
    [createNotification.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [updateNotification.fulfilled]: (state, action) => {
      state.loading = false;
      const index = state.notifications.findIndex(
        (notification) => notification.id === action.payload.id
      );
      if (index !== -1) {
        state.notifications[index] = action.payload;
      }
      state.error = null;
    },
    [deleteNotification.fulfilled]: (state, action) => {
      state.loading = false;
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
      state.error = null;
    },
    [fetchNotifications.pending]: (state) => {
      state.loading = true;
    },
    [fetchNotifications.fulfilled]: (state, action) => {
      state.loading = false;
      state.notifications = action.payload;
      state.error = null;
    },
    [fetchNotifications.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default notificationSlice.reducer;
